import {
  FaFireExtinguisher,
  FaChild,
  FaWater,
  FaBan,
  FaSun,
  FaCheckCircle,
  FaEnvelope,
  FaInstagram,
  FaFacebookF,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaClock,
} from "react-icons/fa";


const safetyTipsData = [
  {
    icon: FaCheckCircle,
    title: "Celebrate a Safe Diwali",
    text: "Enjoy the festival of lights with safety in mind. Follow these tips to protect yourself and your loved ones.",
    image: "/assets/safteyTips/Celebrate-a-Safe-Diwali.png",
  },
  {
    icon: FaChild,
    title: "Supervise Children",
    text: "Always ensure children handle crackers only under adult supervision. Teach them how to light and dispose of crackers safely.",
    image: "/assets/safteyTips/Supervise-Children.png",
  },
  {
    icon: FaFireExtinguisher,
    title: "Keep Fire Safety Nearby",
    text: "Always keep a fire extinguisher, buckets of water, or sand near the area where crackers are being burst.",
    image: "/assets/safteyTips/Keep-Fire-Safety-Nearby.png",
  },
  {
    icon: FaBan,
    title: "Use Crackers Wisely",
    text: "Only burst crackers outdoors in open spaces. Light one cracker at a time and maintain a safe distance immediately after lighting.",
    image: "/assets/safteyTips/Use-Crackers-Wisely.png",
  },
  {
    icon: FaWater,
    title: "Dispose Responsibly",
    text: "After use, soak used crackers in water or cover them with sand before discarding to prevent any risk of delayed combustion.",
    image: "/assets/safteyTips/Dispose-Responsibly.png",
  },
  {
    icon: FaClock,
    title: "Buy Quality, Burst Safely",
    text: "Purchase crackers only from licensed, reliable vendors. Never light them indoors or near flammable items.",
    image: "/assets/safteyTips/Buy-Quality-Burst-Safely.png",
  },
  {
    icon: FaSun,
    title: "Wear Proper Clothing",
    text: "Wear cotton clothes and closed shoes while bursting crackers. Avoid synthetic fabrics that can easily catch fire.",
    image: "/assets/safteyTips/Wear-Proper-Clothing.png",
  },
  {
    icon: FaEnvelope,
    title: "Be Considerate",
    text: "Avoid bursting crackers near hospitals, old age homes, or crowded areas. Your fun should not cause discomfort to others.",
    image: "/assets/safteyTips/Be-Considerate.png",
  },
  {
    icon: FaInstagram,
    title: "Protect Pets",
    text: "Pets are sensitive to loud sounds. Keep them in a safe, quiet room away from noise and light during celebrations.",
    image: "/assets/safteyTips/Protect-Pets.png",
  },
  {
    icon: FaFacebookF,
    title: "Decorate Safely",
    text: "Place diyas and candles away from curtains or flammable materials. Never leave open flames unattended.",
    image: "/assets/safteyTips/Decorate-Safely.png",
  },
  {
    icon: FaMapMarkerAlt,
    title: "Keep a First Aid Kit Ready",
    text: "In case of minor burns or injuries, a well-stocked first aid kit ensures immediate care while waiting for medical help.",
    image: "/assets/safteyTips/Keep-a-First-Aid-Kit-Ready.png",
  },
  {
    icon: FaWhatsapp,
    title: "Spread Awareness",
    text: "Encourage your friends, family, and neighbors to follow these safety practices. Let's make this Diwali safe for all.",
    image: "/assets/safteyTips/Spread-Awareness.png",
  },
];

export default safetyTipsData;